import { Course, CourseSummary, Hole } from '../models/course';
import { getAuthHeaders } from './auth-headers';

class CourseService {
    public async listCourses() {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/courses`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) {
                throw new Error(`Failed to list courses: ${response.status} ${response.statusText}`);
            }
            return {
                body: (await response.json()) as { courses: CourseSummary[] },
                status: response.status,
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async getCourse(id: string) {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/courses/${id}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) {
                throw new Error(`Failed to get course: ${response.status} ${response.statusText}`);
            }
            return {
                body: (await response.json()) as Course,
                status: response.status,
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async createCourse(name: string, holes: Hole[], playerId: string) {
        try {
            const authHeaders = await getAuthHeaders(playerId);
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/courses`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders },
                body: JSON.stringify({ name, holes }),
            });
            if (!response.ok) {
                throw new Error(`Failed to create course: ${response.status} ${response.statusText}`);
            }
            return {
                body: (await response.json()) as Course,
                status: response.status,
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async updateCourse(id: string, updates: { name?: string; holes?: Hole[] }, playerId: string) {
        try {
            const authHeaders = await getAuthHeaders(playerId);
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/courses/${id}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json', ...authHeaders },
                body: JSON.stringify(updates),
            });
            if (!response.ok) {
                throw new Error(`Failed to update course: ${response.status} ${response.statusText}`);
            }
            return {
                body: (await response.json()) as Course,
                status: response.status,
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}

export const courseService = new CourseService();
